var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns level"},[_c('div',{staticClass:"column level-items has-text-centered"},[_c('h1',{staticClass:"title is-centered"},[_vm._v("Game does not exist.")]),_c('h3',[_c('i',{staticClass:"far fa-exclamation-square"})])])])])
}]

export { render, staticRenderFns }